/** Element next to the page title that the table portals the "Bulk Approve (n)" action into. */
export const MONTHLY_REPORT_TITLE_ACTIONS_ID = 'monthly-report-title-actions';

/** Labels whose design wording differs from the shared `common.page.*` keys. */
export const MONTHLY_REPORT_LABELS = {
  requestedDate: 'paymentManagement.affiliatePaymentLogs.monthlyReport.table.requestedDate',
  bankType: 'paymentManagement.affiliatePaymentLogs.monthlyReport.table.bankType',
  accountHolderName: 'paymentManagement.affiliatePaymentLogs.monthlyReport.table.accountHolderName',
  requestedAmount: 'paymentManagement.affiliatePaymentLogs.monthlyReport.table.requestedAmount',
  rejected: 'paymentManagement.affiliatePaymentLogs.monthlyReport.table.rejected',
} as const;
